import { render } from "./MiningPayment.vue?vue&type=template&id=9c5be52c&scoped=true"
import script from "./MiningPayment.vue?vue&type=script&lang=js"
export * from "./MiningPayment.vue?vue&type=script&lang=js"

import "./MiningPayment.vue?vue&type=style&index=0&id=9c5be52c&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c5be52c"]])

export default __exports__